import React, { useState } from 'react'
import { searchcategoryProps } from './searchcategory-interface'

const Searchcategory = ({ title, searchType, results }: searchcategoryProps) => {
  const [collapsed, setCollapsed] = useState(false)

  const getName = (item: any) => {
    switch (searchType) {
      case 'student':
        return `${item.firstName} ${item.lastName}`
      case 'teacher':
        return `${item.firstName} ${item.lastName}`
      case 'lesson':
        return `${item.title}`
      case 'class':
        return `${item.name}`
      case 'curriculum':
        return `${item.name}`
      default:
        return ''
    }
  }

  return (
    <div className={`border-b border-appcolorslightgrey mb-[1.3rem] pb-[][1rem]`}>
      <div className={`flex items-center justify-between py-[0.5rem] ${collapsed ? 'bg-appcolorgreyfive rounded-[10px] mb-[0.9rem] ' : ''}`}>
        <p className='text-appcolorfaintpurple pl-[1.5rem]'>
          {title}
        </p>

        <div className='pr-[1.5rem]'>
          <img src={`/img/vectors/${collapsed ? 'caretdowndown' : 'caretup'}.svg`} alt=""
            onClick={() => {
              setCollapsed(!collapsed)
            }}
            className='cursor-pointer'
          />
        </div>
      </div>

      {
        !collapsed ?
          <>
            {
              searchType === 'search' ?
                <div className='mb-[0.1rem] pl-[2.2rem]'>

                  <div className='flex items-center mb-[0.7rem] cursor-pointer'>
                    <div className='mr-[0.3rem]'>
                      <img src="/img/vectors/recent.svg" alt="" />
                    </div>
                    <p className='text-appcolorpurplefaintone'>
                      Learning how to code with Java
                    </p>
                  </div>
                </div>
                :
                <div className='mb-[0.1rem] pl-[2.2rem] '>
                  {
                    results !== undefined ?
                      results?.length > 0 ?
                        <div>
                          {
                            results.map((item, index) => (
                              <div className='flex items-center cursor-pointer last:pb-[0.5rem]' key={`${title}-${searchType}-${index}`}>
                                <div className='mr-[0.3rem]'>
                                  <img src={`${item.photoURL === '' ? '/img/vectors/usertag.svg' : item.photoURL}`} alt="" className='h-[1.8rem] w-[1.8rem]' />
                                </div>
                                <p className='text-appcolorpurplefaintone pb-[0.5rem]'>
                                  {getName(item)}
                                </p>
                              </div>
                            ))
                          }
                        </div>
                        :
                        <p>
                          No search data found
                        </p>
                      : null
                  }

                </div>
            }
          </>
          : null
      }


    </div>
  )
}

Searchcategory.defaultProps = {
  searchType: 'search'
}

export default Searchcategory